import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type ThemePreference = "system" | "light" | "dark";

interface ThemeStore {
  themePreference: ThemePreference;
  setThemePreference: (t: ThemePreference) => void;
}

// Theme preference lives in its own store so toggling the theme only
// re-renders components that subscribe here (ThemeApplier, ThemeToggle,
// useResolvedTheme consumers). If it sat on `usePersistStore` alongside
// auth/session state, every page that reads the persist store via a
// whole-state selector (`usePersistStore(s => s)`) would re-render on
// theme change — re-mounting their inner data-fetching components and
// firing fresh API calls on every toggle.
export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      themePreference: "system",
      setThemePreference: (t) => set({ themePreference: t }),
    }),
    {
      name: "@BOLLE_THEME",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
